import { render, staticRenderFns } from "./AssignedPermissionsList.vue?vue&type=template&id=178cd5ec&scoped=true"
import script from "./AssignedPermissionsList.vue?vue&type=script&lang=js"
export * from "./AssignedPermissionsList.vue?vue&type=script&lang=js"
import style0 from "./AssignedPermissionsList.vue?vue&type=style&index=0&id=178cd5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178cd5ec",
  null
  
)

export default component.exports